import { render, staticRenderFns } from "./MuscleSelection.vue?vue&type=template&id=79470af0&"
import script from "./MuscleSelection.vue?vue&type=script&lang=js&"
export * from "./MuscleSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports